import { create } from 'zustand';
import { subscriptionApi } from '../services/api';

// NOTE: backend now uses "basic" as primary id; keep "free" for legacy compatibility.
export type SubscriptionPlan = 'basic' | 'free' | 'pro' | 'team' | 'enterprise';

export interface Subscription {
  id: string;
  userId: string;
  plan: SubscriptionPlan;
  status: 'active' | 'expired' | 'canceled' | 'pending';
  startedAt?: string;
  expiresAt?: string;
  createdAt?: string;
  maxWorkflowExecutions: number;
  maxStorageBytes: number;
  currentMonthExecutions: number;
  currentStorageBytes: number;
}

interface SubscriptionState {
  subscription: Subscription | null;
  loading: boolean;
  error: string | null;
  /** 从服务端拉取当前订阅并更新 store，供布局/各页统一使用 */
  fetchSubscription: () => Promise<void>;
  /** 登出时清空，避免残留 */
  clearSubscription: () => void;
}

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  subscription: null,
  loading: false,
  error: null,

  fetchSubscription: async () => {
    set({ loading: true, error: null });
    try {
      const res = await subscriptionApi.getCurrentSubscription();
      if (res.code === 0 && res.data) {
        set({ subscription: res.data, error: null });
      } else {
        set({ subscription: null });
      }
    } catch (err) {
      console.error('Failed to load subscription:', err);
      set({ error: err instanceof Error ? err.message : 'Unknown error' });
    } finally {
      set({ loading: false });
    }
  },

  clearSubscription: () => set({ subscription: null, error: null }),
}));
